<template>
  <div>
    <div class="home">
      <div class="home-left">
        <div class="home-left-nav">
          <div></div>
          <ul>
            <li @click="open('author')">作者投稿</li>
            <li @click="open('author')">作者查稿</li>
            <li @click="open('expert')">专家审稿</li>
            <li @click="open('admin')">编辑办公</li>
          </ul>
        </div>

        <div class="home-right-list" style="height: 318px">
          <div @click="jumpList(12830, '通知公告', true)" style="cursor: pointer">
            <img src="@/assets/tzgg.svg" />
          </div>
          <ul>
            <li
              style=""
              @click="jump(item.contentID, 12830, '通知公告')"
              v-for="item in announcementList"
            >
              <span> </span>
              <div>
                {{ item.title }}
              </div>
            </li>
          </ul>
        </div>

        <div class="home-right-list" style="margin-top: 16px; height: 318px">
          <div @click="jumpList(12831, '期刊动态', true)" style="cursor: pointer">
            <img src="@/assets/qkdt.svg" />
          </div>
          <ul>
            <li
              v-for="item in dynamicList"
              @click="jump(item.contentID, 12831, '期刊动态')"
            >
              <span> </span>
              <div v-html="item.title"></div>
            </li>
          </ul>
        </div>

        <!-- 期刊检索 -->
        <div class="home-right-list">
          <div style="position: relative">
            <img src="@/assets/gkjsxt.svg" />
          </div>
          <div class="issue-search">
            <div>
              <div>标题：</div>
              <el-input
                @keyup.enter.native="search"
                v-model="form.title"
                placeholder="请输入标题"
              ></el-input>
            </div>
            <div>
              <div>关键词：</div>
              <el-input
                @keyup.enter.native="search"
                v-model="form.keywords"
                placeholder="请输入关键词"
              ></el-input>
            </div>
            <div>
              <div>作者姓名：</div>
              <el-input
                @keyup.enter.native="search"
                v-model="form.authors"
                placeholder="请输入作者姓名"
              ></el-input>
            </div>
            <div>
              <div>作者单位：</div>
              <el-input
                @keyup.enter.native="search"
                v-model="form.unit"
                placeholder="请输入作者单位"
              ></el-input>
            </div>

            <div>
              <div>期刊年份：</div>
              <div style="display: flex; align-items: center">
                <el-input
                  @keyup.enter.native="search"
                  v-model="form.startYear"
                  placeholder="起始年份"
                  style="margin-bottom: 0"
                ></el-input>
                <img src="@/assets/hx.svg" style="margin: 0 18px" />
                <el-input
                  @keyup.enter.native="search"
                  v-model="form.endYear"
                  placeholder="结束年份"
                  style="margin-bottom: 0"
                ></el-input>
              </div>
            </div>
            <div class="search" @click="search">
              <img src="@/assets/ss.svg" />
              搜索
            </div>
          </div>
        </div>
      </div>
      <div class="home-center">
        <div>
          <el-carousel height="400px">
            <el-carousel-item v-for="item in swiperList" :key="item.titlePhoto">
              <div style="display: flex; flex-direction: column; height: 400px">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    height: 400px;
                    justify-content: center;
                  "
                >
                  <img
                    style="max-width: 100%; max-height: 100%; width: auto; height: auto"
                    model="cover"
                    :src="item.titlePhoto"
                    @click="jumpLink(item)"
                  />
                </div>
                <div class="carousel-title">
                  {{ item.title }}
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="issue">
          <div class="issue-tab">
            <span :class="isShow == 1 ? 'cover' : ''" @click="isShow = 1">
              当期目录
            </span>
            <span :class="isShow == 2 ? 'cover' : ''" @click="isShow = 2">
              过刊浏览
            </span>
            <span :class="isShow == 3 ? 'cover' : ''" @click="isShow = 3">
              专题专辑
            </span>
          </div>
          <ul class="issue-list" v-if="isShow == 1">
            <!-- <div class="issue-tips">
              重大主题专栏 <span> {{zhuanLanList[0]?.channelName||''}} </span>
            </div>
            <li v-for="(item, index) in zhuanLanList" :style="index===zhuanLanList.length-1?'border-bottom:none;':''">
              <span>{{ index + 1 }}</span>
              <div>
                <div
                  class="issue-title"
                  style="cursor: pointer"
                  @click="issueDetail(item)"
                >
                  {{ item.title }}
                </div>
             
                <div class="issue-author">作者：{{ item.authors }}</div>
                <div class="issue-down">
                  <div>{{ item.year }}年 第{{ item.issue }}期</div>
                  <div>
                    <span @click="issueDetail(item)"> 【查看全文】 </span>
                    <span v-if="item.filePath" @click="link(item.filePath, true, item)">
                      【下载全文】
                    </span>
                    <span v-if="item.filePath2" @click="link(item.filePath2)">
                      【下载附录】</span
                    >
                    <span v-if="item.otherPath" @click="link(item.otherPath)">
                      【下载程序代码】
                    </span>
                  </div>
                </div>
              </div>
            </li>
            <img src="@/assets/hw.svg" style="margin-bottom: 16px;" /> -->
            <div v-for="(items, index) in currentIssueList">
              <div class="issue-tips" v-if="items.channelName">
                {{ items.channelName }}
              </div>
              <img v-else src="@/assets/hw.svg" style="margin-bottom: 16px" />
              <div v-if="items.channels && items.channels.length">
                <div v-for="channels in items.channels">
                  <div class="channelName" v-if="channels.channelName">
                    {{ channels.channelName }}
                  </div>
                  <li v-for="item in channels.issueInfoList">
                    <!-- <span>{{ index + zhuanLanList.length + 1 }}</span> -->
                    <div>
                      <div
                        class="issue-title"
                        style="cursor: pointer"
                        @click="issueDetail(item)"
                      >
                        {{ item.title }}
                      </div>

                      <div class="issue-author">作者：{{ item.authors }}</div>
                      <div class="issue-down">
                        <div>{{ item.year }}年第{{ item.issue }}期</div>
                        <div>
                          <span @click="issueDetail(item)"> 【查看全文】 </span>
                          <span
                            v-if="item.filePath"
                            @click="link(item.filePath, true, item)"
                          >
                            【下载全文】
                          </span>
                          <span v-if="item.filePath2" @click="link(item.filePath2)">
                            【下载附录】</span
                          >
                          <span v-if="item.otherPath" @click="link(item.otherPath,true,item,'数据代码_'+item.title)">
                            【下载程序代码】
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                </div>
              </div>
              <div v-else>
                <li v-for="item in items.issueInfoList">
                  <!-- <span>{{ index + zhuanLanList.length + 1 }}</span> -->
                  <div>
                    <div
                      class="issue-title"
                      style="cursor: pointer"
                      @click="issueDetail(item)"
                    >
                      {{ item.title }}
                    </div>

                    <div class="issue-author">作者：{{ item.authors }}</div>
                    <div class="issue-down">
                      <div>{{ item.year }}年第{{ item.issue }}期</div>
                      <div>
                        <span @click="issueDetail(item)"> 【查看全文】 </span>
                        <span
                          v-if="item.filePath"
                          @click="link(item.filePath, true, item)"
                        >
                          【下载全文】
                        </span>
                        <span v-if="item.filePath2" @click="link(item.filePath2,true,item)">
                          【下载附录】</span
                        >
                        <span v-if="item.otherPath" @click="link(item.otherPath,true,item,'数据代码_'+item.title)">
                          【下载程序代码】
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
            </div>
          </ul>

          <div
            class="issue-year"
            style="height: 1117px; overflow-y: auto"
            v-else-if="isShow == 2"
          >
            <div v-for="item in issueLists">
              <div style="cursor: pointer">
                <div style="line-height: 31px">{{ item.year }}年</div>
                <div
                  style="line-height: 31px; text-align: center; color: #00326a"
                  @click="directory(item.year)"
                >
                  总目录
                </div>
              </div>
              <div class="line"></div>
              <div class="issue-year-list">
                <div
                  v-for="(issue, index) in item.issueLists"
                  :style="
                    index > 5 || item.issueLists.length <= 6 ? 'margin-bottom:0;' : ''
                  "
                >
                  <li
                    @click="
                      yearIssue({
                        issue: issue.issue,
                        year: item.year,
                      })
                    "
                  >
                    第{{ issue.issue }}期
                  </li>
                  <span v-if="(index + 1) % 6 != 0"></span>
                </div>
              </div>
            </div>
          </div>

          <ul
            class="issue-list"
            v-if="isShow == 3"
            style="height: 1125px; overflow-y: auto"
          >
            <li v-for="(item, index) in specialIssueList" style="display: flex">
              <span>{{ index + 1 }}</span>
              <div>
                <div
                  class="issue-title"
                  style="cursor: pointer"
                  @click="jump2(item.linkUrl, item.title)"
                >
                  {{ item.title }}
                </div>
                <!-- <div class="issue-titleEn">
                  A Study on Farmers' Willingness to Participate in Rural Ecotourism
                  Construction from the Perspective of Property Rights Incentives—Based on
                  Survey Data from 88 Villages in Yunnan Province
                </div> -->
                <!-- <div class="issue-author">作者：{{ item.authors }}</div> -->
                <!-- <div class="issue-down">
                  <div>{{ item.year }}年 第{{ item.issue }}期</div>
                  <div>
                    <span @click="issueDetail(item)"> 【查看全文】 </span>
                    <span @click="link(item.filePath, true, item)"> 【下载全文】 </span>
                    <span @click="link(item.filePath2)"> 【下载附录】</span>
                    <span @click="link(item.filePath2)"> 【下载程序代码】 </span>
                  </div>
                </div> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="home-right">
        <div
          style="
            height: 400px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <img @click="jump1()" :src="logoImg" style="width: 230px; cursor: pointer" />
        </div>

        <div class="home-right-list" style="margin-top: 16px; height: 318px">
          <div @click="jumpList(12854, '时事热点', true)" style="cursor: pointer">
            <img src="@/assets/ssrd.svg" />
          </div>
          <ul>
            <li
              v-for="item in hotTopicList"
              @click="jump(item.contentID, 12854, '时事热点')"
            >
              <span> </span>
              <div v-html="item.title"></div>
            </li>
          </ul>
        </div>

        <div class="home-right-list" style="margin-top: 16px; height: 318px">
          <div @click="jumpList(12855, '社科动态', true)" style="cursor: pointer">
            <img src="@/assets/skdt.svg" />
          </div>
          <ul>
            <li
              v-for="item in socialList"
              @click="jump(item.contentID, 12855, '社科动态')"
            >
              <span> </span>
              <div v-html="item.title"></div>
            </li>
          </ul>
        </div>

        <div class="home-right-list" style="height: 268px; overflow-y: hidden">
          <div @click="jumpList(12832, '论文获奖', true)" style="cursor: pointer">
            <img src="@/assets/lwhj.svg" />
          </div>
          <ul>
            <li
              v-for="item in certificateList"
              @click="jump(item.contentID, 12832, '论文获奖')"
            >
              <span> </span>
              <div>
                {{ item.title }}
              </div>
            </li>
          </ul>
        </div>

        <div class="home-right-list" style="height: 269px">
          <div @click="jumpList(12833, '友情链接')" style="cursor: pointer">
            <img src="@/assets/yqlj.svg" />
          </div>
          <ul>
            <li
              v-for="item in linkList"
              @click="link(item.linkUrl)"
              style="
                border: none;

                height: auto;
              "
            >
              <div
                style="
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  display: block;
                "
              >
                {{ item.title }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="honor">
      <img src="@/assets/qkry.svg" style="margin-bottom: 9px" />
      <vue-seamless-scroll
        :data="honorList"
        :class-option="classOption"
        class="warp"
        v-if="isScrollShow"
      >
        <ul class="ul-item scroll-content">
          <li
            class="li-item item"
            style="position: relative"
            v-for="(item, index) in visibleData"
            :key="index"
            @click="imgPreview(index)"
          >
            <!-- {{ item }} -->
            <img style="height: 130px" :src="item" @click="imgPreview(index)" />
            <div
              style="position: absolute; top: 0; left: 0; right: 0; bottom: 0"
              @click="imgPreview(index)"
            >
              <!-- <img style="height: 130px" :src="item" /> -->
              <el-image
                style="height: 130px"
                :src="item"
                :preview-src-list="honorList"
                ref="imgqwq"
              >
              </el-image>
            </div>
            <!-- <el-image :src="item" :preview-src-list="honorList"> </el-image> -->
          </li>
        </ul>

        <!-- <div class="scroll-container">
          <div class="scroll-content" ref="scrollContent">
      
            <li v-for="(item, index) in honorList" :key="index" class="item">
              <el-image style="height: 130px" :src="item" :preview-src-list="honorList">
              </el-image>
            </li>
          </div>
        </div> -->
      </vue-seamless-scroll>
    </div>

    <!-- <el-image-viewer
      v-if="showPreview"
      :url-list="honorList"
      show-progress
      :initial-index="currImgIndex"
      @close="showPreview = false"
    /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import vueSeamlessScroll from "vue-seamless-scroll";
let x = 0;
export default {
  name: "HomeView",
  data() {
    return {
      scrollSpeed: 60,
      tempInterval: undefined,
      logoImg: "",
      isShow: 1,
      input: "",
      menuList: [
        {
          title: "作者投稿",
          query: {},
        },
        {
          title: "作者查稿",
          query: {},
        },
        {
          title: "专家审稿",
          query: {},
        },
        {
          title: "编辑办公",
          query: {},
        },
      ],
      diplomaList: [],
      announcementList: [],
      dynamicList: [],
      hotTopicList: [],
      certificateList: [],
      linkList: [],
      swiperList: [],
      honorList: [],
      visibleData: [],
      issueLists: [],
      currentIssueList: [],
      zhuanLanList: [],
      form: {},
      specialIssueList: [],
      socialList: [],
      classOption: {
        limitMoveNum: 2,
        direction: 2,
      },
      showPreview: false,
      currImgIndex: 1,
      isScrollShow: false,
    };
  },
  destroyed() {
    clearInterval(this.tempInterval);
  },
  components: {
    vueSeamlessScroll,
  },
  computed: {},
  methods: {
    imgPreview(index) {
      // alert('11')
      // this.currImgIndex = index;
      // this.showPreview = true;
    },
    jump2(id, title) {
      this.$router.push({
        path: "/projectList",
        query: {
          channelId: id,
          title: title,
        },
      });
    },

    jumpLink({ linkUrl }) {
      this.$router.push({
        path: linkUrl,
      });
    },
    yearIssue(query) {
      this.$router.push({
        path: "/search",
        query,
      });
    },
    directory(year) {
      this.$post("IssueContentApi/GetIssueNormalSearch", {
        curr: this.curr,
        year: year,
        limit: 10,
        JChannelID: 1822,
      }).then((res) => {
        if (res.data[0]?.filePath) {
          console.log(res.data[0]?.filePath, "啦啦啦");
          window.open(res.data[0].filePath);
        }
        console.log(res, "无敌了");
      });
    },
    getAnnouncement() {
      this.$post("JournalInfoApi/GetSiteContentPageList", {
        channeID: 12830,
        curr: 1,
        limit: 3,
        pChanneID: 0,
      }).then((res) => {
        this.announcementList = res.data;
      });
    },
    getDynamicList() {
      this.$post("JournalInfoApi/GetSiteContentPageList", {
        channeID: 12831,
        curr: 1,
        limit: 3,
        pChanneID: 0,
      }).then((res) => {
        this.dynamicList = res.data;
      });
    },
    getHotTopicList() {
      this.$post("JournalInfoApi/GetSiteContentPageList", {
        channeID: 12854,
        curr: 1,
        limit: 3,
        pChanneID: 0,
      }).then((res) => {
        this.hotTopicList = res.data;
      });
    },
    getSocialList() {
      this.$post("JournalInfoApi/GetSiteContentPageList", {
        channeID: 12855,
        curr: 1,
        limit: 3,
        pChanneID: 0,
      }).then((res) => {
        this.socialList = res.data;
      });
    },

    getCertificateList() {
      this.$post("JournalInfoApi/GetSiteContentPageList", {
        channeID: 12832,
        curr: 1,
        limit: 3,
        pChanneID: 0,
      }).then((res) => {
        this.certificateList = res.data;
      });
    },
    getLinkList() {
      this.$post("JournalInfoApi/GetSiteContentPageList", {
        channeID: 12833,
        curr: 1,
        limit: 4,
        pChanneID: 0,
      }).then((res) => {
        this.linkList = res.data;
      });
    },
    getSwiperList() {
      this.$post("JournalInfoApi/GetSiteContentPageList", {
        channeID: 12834,
        curr: 1,
        limit: 10,
        pChanneID: 0,
      }).then((res) => {
        this.swiperList = res.data;
      });
    },
    rollTemp() {
      let all = 0;
      let count = this.$refs.temp.childElementCount;
      for (let i = 0; i < count; i++) {
        all += this.$refs.temp.children[i].offsetWidth;
      }
      let half = all >> 1;
      if (x < 1 - half) {
        x = 0;
      }
      x -= 1;
      this.$refs.temp.style.transform = "translateX(" + x + "px)";
    },
    getHonorList() {
      this.isScrollShow = false;
      this.$post("JournalInfoApi/GetSiteContentPageList", {
        channeID: 12835,
        curr: 1,
        limit: 10,
        pChanneID: 0,
      }).then((res) => {
        this.honorList = res.data.map((item) => {
          return item.titlePhoto;
        });
        this.honorList = [...this.honorList, ...this.honorList];
        // this.$nextTick((_) => {
        this.visibleData = [...this.honorList]; // 初始双份数据
        setTimeout((_) => {
          this.$nextTick((_) => {
            this.isScrollShow = true;
          });
        });
        //   // this.tempInterval = setInterval(this.rollTemp, 10);
        // });
      });
    },
    GetYearVolumeTree() {
      this.$get("SiteWebApi/GetYearVolumeTree", {}).then((res) => {
        res.data.forEach((item) => {
          item.issueLists = item.issueLists.reverse();
        });
        this.issueLists = res.data;
      });
    },
    GetCurrentPeriod() {
      this.$get("SiteWebApi/GetCurrentPeriodMutiChannel", {}).then((res) => {
        this.currentIssueList = res.data.channels;
        // this.zhuanLanList = res.data.data
      });
    },
    getSpecialIssueList() {
      this.$post("JournalInfoApi/GetSiteContentPageList", {
        channeID: 12845,
        curr: 1,
        limit: 10,
        pChanneID: 0,
      }).then((res) => {
        this.specialIssueList = res.data;
      });
      // this.$get("IssueContentApi/GetIssueTypeName", {
      //
      // }).then((res) => {
      //   console.log(res, "zhahdas");
      //   this.specialIssueList = res.data;
      // });
    },
    link(link, type, item,name) {
      if (type) {
        var index = item.authors && item.authors.indexOf("&nbsp");
        var resolve = item.authors && item.authors.substring(0, index);
        const fileType = link.substring(link.lastIndexOf(".") + 1);
        this.downloadFile(link, (name || item.title + "_" + item.authors )+ "." + fileType);
      } else {
        window.open(link);
      }
    },
    async downloadFile(url, filename) {
      const blob = await fetch(url).then((res) => res.blob());
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    jumpList(channelId, title, type) {
      this.$router.push({
        path: "/list",
        query: {
          channelId,
          title,
          type: type,
        },
      });
    },
    search() {
      this.$router.push({
        path: "/searchList",
        query: this.form,
      });
    },
    issueDetail(item) {
      this.$router.push({
        path: "/issueDetail",
        query: {
          contentId: item.id,
          year: item.year,
          issue: item.issue,
          title: "当期目录",
        },
      });
    },
    jump(id, channelId, title) {
      this.$router.push({
        path: "/detail",
        query: {
          id,
          channelId,
          title,
        },
      });
    },
    jump1() {
      this.$router.push({
        path: "/search",
      });
    },
    open(type) {
      window.open("/Admin/user/login?group=" + type);
    },
    init() {
      this.getAnnouncement();
      this.getDynamicList();
      this.getHotTopicList();

      this.getSocialList();
      this.getCertificateList();
      this.getLinkList();
      this.getSwiperList();
      this.getHonorList();
      this.GetYearVolumeTree();
      this.GetCurrentPeriod();
      this.getSpecialIssueList();
      this.GetThatYearIssueList();
    },
    GetThatYearIssueList() {
      this.$get("SiteWebApi/GetThatYearIssueList", {}).then((res) => {
        let arr = res.data.filter((item) => {
          return item.status == 1;
        });
        const maxObj = arr.reduce(
          (max, item) => (item.issue > max.issue ? item : max),
          arr[0]
        );
        this.logoImg = maxObj.titlePhoto;
        // this.currentIssueList = res.data.issueInfoList;
      });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
.home {
  display: flex;
  width: 1400px;
  margin: 0 auto;
  &-left {
    width: 300px;
    &-nav {
      margin-bottom: 16px;
      padding: 40px 24px 0;
      width: 300px;
      height: 400px;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.16);
      > div {
        margin-bottom: 24px;
        width: 252px;
        height: 36px;
        background: url("@/assets/cbxt.svg") no-repeat;
        background-size: 100% 100%;
      }
      li {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        width: 252px;
        height: 48px;
        border-radius: 4px;
        background: #e1ebff;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0em;
        color: #000000;
        list-style: none;
        cursor: pointer;
      }
      li:hover {
        background-color: #00326a;
        color: #fff;
      }
    }
  }
  &-center {
    margin: 0 16px 16px;
    width: 768px;
    .carousel-title {
      left: 0;
      right: 0;
      padding-left: 24px;
      position: absolute;
      bottom: 0;
      height: 60px;
      /* 自动布局 */
      display: flex;
      align-items: center;
      background: rgba(0, 0, 0, 0.2);
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0px;
      color: #ffffff;
    }
    .issue {
      margin-top: 16px;
      width: 768px;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.16);
      padding: 20px 0 20px 24px;
      &-tab {
        display: flex;
        span {
          margin-right: 8px;
          width: 96px;
          height: 40px;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        span:hover {
          color: #002957;
        }
        .cover {
          background-color: #00326a;
          color: #fff !important;
        }
      }
      &-tips {
        margin-bottom: 20px;
        padding-left: 12px;
        height: 36px;
        border-radius: 2px;
        background: #f5f5f5;
        border-left: 4px solid #00326a;
        display: flex;
        align-items: center;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 600;
        line-height: 150%;
        text-align: center;
        letter-spacing: 0px;
        color: #00326a;
        span {
          margin-left: 24px;
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: normal;
          line-height: 150%;
          text-align: center;
          letter-spacing: 0px;
          color: rgba(0, 0, 0, 0.65);
        }
      }
      &-list {
        margin-top: 16px;
        height: 1125px;
        overflow-y: auto;
        overflow-x: hidden;
        li {
          margin-bottom: 12px;
          // display: flex;
          border-bottom: 0.5px solid #eeeeee;
          padding-bottom: 22px;
          > span {
            width: 10px;
            height: 31px;
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 600;
            line-height: 25px;
            letter-spacing: 0px;
            color: rgba(0, 0, 0, 0.85);
          }
          > div {
            margin-left: 8px;
            flex: 1;
            margin-right: 20px;

            .issue-title {
              font-family: PingFang SC;
              font-size: 16px;
              font-weight: 600;
              line-height: 26px;
              letter-spacing: 0px;
              color: rgba(0, 0, 0, 0.85);
            }
            .issue-title:hover {
              color: #00326a;
            }
            .issue-titleEn {
              margin: 4px 0 12px;
              font-family: PingFang SC;
              font-size: 16px;
              font-weight: 600;
              line-height: 24px;
              letter-spacing: 0px;
              font-variation-settings: "opsz" auto;
              color: rgba(0, 0, 0, 0.85);
            }
            .issue-author {
              margin-top: 12px;
              margin-bottom: 12px;
              font-family: PingFang SC;
              font-size: 16px;
              font-weight: normal;
              line-height: normal;
              letter-spacing: 0px;
              color: rgba(0, 0, 0, 0.65);
            }
            .issue-down {
              display: flex;
              justify-content: space-between;
              div {
                font-family: PingFang SC;
                font-size: 16px;
                letter-spacing: 0px;
                color: rgba(0, 0, 0, 0.65);
              }
              span {
                margin-left: 8px;
                cursor: pointer;
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: normal;
                line-height: normal;
                letter-spacing: 0px;
                color: #00326a;
              }
              span:hover {
                color: #002957;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
  }
  &-right {
  }

  .home-right-list {
    margin-bottom: 16px;
    padding: 24px 16px 24px;
    width: 300px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.16);
    > div:first-of-type {
      margin-bottom: 24px;
      height: 36px;
    }
    ul {
      padding-left: 10px;
      > li:last-of-type {
        margin-bottom: 0;
      }
    }
    li {
      margin-bottom: 16px;
      position: relative;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: normal;
      line-height: normal;
      text-align: justify; /* 浏览器可能不支持 */
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.85);
      list-style: none;
      padding-bottom: 8px;
      border-bottom: 0.5px solid #eeeeee;
      cursor: pointer;
      z-index: 1;
      line-height: 21px;

      height: 51px;

      display: flex;
      > span {
        min-width: 5px;
        height: 5px;
        transform: rotate(45deg);
        opacity: 1;
        display: flex;
        background: #00326a;
        margin-right: 10px;
        margin-top: 8px;
      }
      > div {
        flex: 1;
        word-break: break-all;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    li:hover {
      color: #00326a;
    }
  }

  .issue-search {
    > div {
      > div {
        width: 252px;
        margin-bottom: 8px;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 600;
        line-height: 150%;
        letter-spacing: 0px;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .search {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      width: 252px;
      cursor: pointer;
      height: 48px;
      border-radius: 4px;
      background: #00326a;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0em;
      font-variation-settings: "opsz" auto;
      color: #ffffff;
      img {
        margin-right: 8px;
      }
    }
    .search:hover {
      background-color: #002957;
    }
  }
}

.honor {
  padding: 24px 24px 20px 24px;
  width: 1400px;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.16);
  overflow: hidden;
  li {
    list-style: none;
    margin: 6px;
    padding: 5px;
  }
}

.issue-year {
  margin-top: 24px;
  height: 833px;
  overflow-y: auto;
  > div {
    margin-right: 20px;
    margin-bottom: 16px;
    padding: 8px 10px;
    display: flex;
    align-items: center;
    // height: 90px;
    background: #f9f9f9;
    > div:first-of-type {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: bold;
      line-height: 60px;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.85);
    }

    .line {
      margin: 0 15px 0 22px;
      height: 60px;
      width: 1px;
      background-color: #eeeeee;
    }
    .issue-year-list {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      > div {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        span {
          margin: 0 11px;
          display: flex;
          height: 16px;
          width: 1px;
          background-color: #eeeeee;
        }
      }
    }

    li {
      list-style: none;
      width: 76px;
      height: 31px;
      border-radius: 4px;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: bold;
      line-height: 31px;
      text-align: center;
      letter-spacing: 0px;
      color: #000000;
      cursor: pointer;
    }
    li:hover {
      background: #00326a;
      color: #fff;
    }
  }
}

::v-deep .el-input__inner {
  padding: 0 8px;
}
::v-deep .el-input__inner:focus {
  border-color: #00326a !important;
}

::v-deep .el-carousel__indicators {
  right: 70px;
  left: auto;
  transform: none;
  bottom: 10px;
  .el-carousel__button {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
}

.scroll-temp {
  width: 100%;
  overflow: hidden;
  .temp-box {
    white-space: nowrap;
    li {
      display: inline-block;
    }
  }
}

.scroll-container {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}

@keyframes scrollLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%); /* 滚动到中间位置 */
  }
}

.item {
  display: inline-block;
  padding: 10px;
  // max-width: 180px;
  background: #f5f5f5;
  list-style: none;
  margin: 6px;
  padding: 5px;
}
.warp {
  width: 100%;
  height: 130px;
  margin: 0 auto;
  overflow: hidden;
  ::v-deep > div {
    overflow: visible !important;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    &.ul-item {
      display: flex;
    }
  }
}
.channelName {
  margin-bottom: 5px;
  display: inline-block !important;
  height: 26px;
  border-radius: 4px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  padding: 0px 8px;
  background: #00326a;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0px;
  color: #ffffff;
}
</style>
